import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as _html2canvas from "html2canvas";
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
const html2canvas: any = _html2canvas;


@Component({
  selector: 'app-package-receipt',
  templateUrl: './package-receipt.component.html',
  styleUrls: ['./package-receipt.component.css']
})
export class PackageReceiptComponent implements OnInit {
  model: any;
  pack: any;
  customer_id: any;
  complementry: any;
  showLoader: boolean = false;
  module_access: any;
  modChange: boolean = false;
  billDateChange: boolean = false;
  currentUser: any;
  todayDate: string = '';
  base64Image: any;
  gstEnabled: boolean = false;
  cgst: number = 0;
  sgst: number = 0;
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    // This will disable dates starting from tomorrow
  };
  constructor(
    private router: Router,
    private activerouter: ActivatedRoute,
    private loginservice: LoginService,
    private _flashMessagesService: FlashMessagesService
  ) {
    const today = new Date();
    this.todayDate = today.toISOString().split('T')[0]; // yyyy-MM-dd
  }

  ngOnInit() {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.gstEnabled = this.currentUser['gstEnabled'];
    if (this.gstEnabled == true) {
      // this.cgst = 0;
      // this.sgst = 0;
      this.cgst = this.currentUser['cgst'];
      this.sgst = this.currentUser['sgst'];
    } else {
      this.cgst = 0;
      this.sgst = 0;
    }
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    this.modChange = this.checkModuleAcces('34');
    this.billDateChange = this.checkModuleAcces('33');


    this.activerouter.queryParams.subscribe(params => {
      this.model = JSON.parse(params['model']);
      this.pack = JSON.parse(params['pack']);
      const match = this.model.packs.find(p => p.mem_id == this.pack.service_category_id);
      if (match) this.pack.purchased_date = match.date;
      this.customer_id = params['customer_id']
    }, error => { alert('Network Error params API'); });

    if (this.pack.start_date != '0000-00-00' && this.pack.start_date != null && this.pack.start_date != '') {
      this.pack.start_date1 = this.pack.start_date;
      this.pack.start_date = this.loginservice.stringToDate(this.pack.start_date);
    } else {
      this.pack.start_date1 = '';
    }


    if (this.pack.end_date != '0000-00-00' && this.pack.end_date != null && this.pack.end_date != '') {
      this.pack.end_date1 = this.pack.end_date;
      this.pack.end_date = this.loginservice.stringToDate(this.pack.end_date);
    } else {
      this.pack.end_date1 = '';
    }

    this.model.memStartDate1 = this.loginservice.Objecttodate(this.model.memStartDate)
    this.model.memEndDate1 = this.loginservice.Objecttodate(this.model.memEndDate)

    this.model.totPerson = 1;

    if (this.model.person1phone > 0) {
      this.model.totPerson += 1;
    }

    if (this.model.person2phone > 0) {
      this.model.totPerson += 1;
    }

    if (this.customer_id) {
      this.model['service_category'] = this.pack['service_category'];
      this.model['memAmt'] = this.pack['memAmt'];
      this.model['compMonth'] = this.pack['compMonth'];
      const offered = this.pack.offered || [];
      // Create map
      const map: any = {};
      offered.forEach(o => {
        const desc = o.service_desc;

        if (!map[desc]) {
          map[desc] = { service_desc: desc, count: 1 };
        } else {
          map[desc].count++;
        }
      });
      // Convert map → array
      this.complementry = Object.keys(map).map(key => map[key]);
    }
  }

  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      return true; // module exists
    } else {
      // If not found, reset and return false
      return false;
    }
  }

  convertToWords(number: number): string {
    // Define an array of words for numbers 0 to 19
    const units: string[] = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

    // Define an array of words for tens multiples
    const tensMultiples: string[] = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    // Define an array of words for powers of thousand
    const tensPowers: string[] = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

    // Function to convert numbers less than 1000 to words
    const convertLessThanOneThousand = (num: number): string => {
      if (num === 0) {
        return '';
      }

      let word = '';

      if (num < 20) {
        word = units[num];
      } else if (num < 100) {
        word = tensMultiples[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + units[num % 10] : '');
      } else {
        word = units[Math.floor(num / 100)] + ' Hundred ' + convertLessThanOneThousand(num % 100);
      }

      return word.trim();
    };

    // Function to convert large numbers to words
    const convertToWordsHelper = (num: number, power: number): string => {
      if (num === 0) {
        return '';
      }

      const higherPart = Math.floor(num / 1000);
      let word = '';

      // Call recursively if there's a higher part (greater than 1000)
      if (higherPart > 0) {
        word = convertToWordsHelper(higherPart, power + 1);
      }

      const remainder = convertLessThanOneThousand(num % 1000);

      if (remainder) {
        word += (word ? ' ' : '') + remainder + ' ' + tensPowers[power];
      }

      return word.trim();
    };

    // Handle the decimal part (if applicable)
    const handleDecimalPart = (num: number): string => {
      const decimalPart = Math.round((num % 1) * 100); // Get the fractional part as an integer (e.g., 79.2 => 20)
      if (decimalPart > 0) {
        if (decimalPart < 20) {
          return ' point ' + units[decimalPart] + ' paisa'; // Convert to words for numbers below 20
        } else {
          return ' point ' + tensMultiples[Math.floor(decimalPart / 10)] + ' ' + (decimalPart % 10 !== 0 ? units[decimalPart % 10] + ' paisa' : 'paisa');
        }
      }
      return '';
    };

    if (number === 0) {
      return 'Rupees Zero Only';
    }

    // Separate the integer part and decimal part
    const integerPart = Math.floor(number);
    const decimalPart = handleDecimalPart(number);

    // Convert the integer part to words and append the decimal part if it exists
    const words = convertToWordsHelper(integerPart, 0).trim();

    // Return the final output with "Rupees" and "paisa" formatting
    return 'Rupees ' + words + decimalPart;
  }

  public mprint() {
    window.print();
  }

  packdateChange() {
    if (this.pack.purchased_date) {
      const selectedDate = new Date(this.pack.purchased_date);
      const today = new Date(this.todayDate);
      // Reset if selected date is in the future
      if (selectedDate > today) {
        alert('Future dates are not allowed!');
        this.pack.purchased_date = this.todayDate; // Reset to today's date or clear

        // Optional: Notify backend or log this action (if required)
        return;
      }
      // Proceed with valid date
      this.loginservice.packdateChange(this.pack, this.currentUser).subscribe(
        (data) => {
        },
        (error) => {
          alert('Network Error packdateChange API');
          console.error('Error updating date:', error);
        }
      );
    }
  }

  savePackagepaymentMode() {
    if ((this.pack.start_date == '0000-00-00' && this.pack.start_date == null && this.pack.start_date == '') || (this.pack.end_date == '0000-00-00' && this.pack.end_date == null && this.pack.end_date == '')) {
      alert('Please select Start Date and End Date');
      return false;
    }

    let totPay = (Number(this.pack.cash) || 0) + (Number(this.pack.g_pay) || 0) + (Number(this.pack.card) || 0) + (Number(this.pack.cheque) || 0) + (Number(this.pack.due) || 0) + (Number(this.pack.online_banking) || 0) + (Number(this.pack.salary) || 0);

    let allAmt = this.roundGst(Number(this.pack.memAmt) + ((Number(this.pack.memAmt) * Number(this.sgst)) / 100) + ((Number(this.pack.memAmt) * Number(this.cgst)) / 100))
    this.pack.cgst = this.cgst;
    this.pack.sgst = this.sgst;
    this.pack.cgst_amt = (Number(this.pack.memAmt) * Number(this.cgst)) / 100;
    this.pack.sgst_amt = (Number(this.pack.memAmt) * Number(this.sgst)) / 100;

    if (allAmt === Number(Number(totPay).toFixed(1))) {
      this.loginservice.savePackagepaymentMode(this.pack, this.currentUser)
        .subscribe(
          data => {
            setTimeout(() => { this.captureAndSend() }, 1000);
            this._flashMessagesService.show('Payment Mode Saved!', { cssClass: 'alert-success' });
          }, error => { alert('Network Error savePackagepaymentMode API'); });
    } else {
      alert('Mis-match')
    }
  }

  captureAndSend() {
    this.showLoader = true;
    const element = document.getElementById('divToPrint');
    if (element) {
      html2canvas(element, {
        scale: 2,               // Increase the scale for higher resolution
        useCORS: true,          // Enable CORS for external images
        allowTaint: true,       // Allow tainted images
        backgroundColor: null   // Set to null to keep transparent background, if needed
      }).then(canvas => {
        // Convert canvas to JPEG base64 string
        this.base64Image = canvas.toDataURL('image/jpeg', 1.0);

        // Send the base64 image to the server
        this.loginservice.sendPackageDetails(this.base64Image, this.pack.id, this.currentUser).subscribe(
          response => {
            this.showLoader = false;
          },
          error => {
            alert('Network Error sendPackageDetails API');
            this.showLoader = false;
            console.error('Error saving image', error);
          }
        );
      }).catch(error => {
        this.showLoader = false;
        console.error('Error capturing element with html2canvas', error);
      });
    } else {
      this.showLoader = false;
      console.error('Element not found');
    }
  }

  onDateChanged(type, event: IMyDateModel): void {
    // date selected
    if (type === 'month') {
      this.model['getmonth'] = event;

    } else {
      this.model['getyear'] = event;
    }
  }

  roundGst(value) {
    return Math.round(value);
  }

  getBillLogoPath(): string {
    if (this.currentUser && this.currentUser.billLogo) {
      // If salon has custom bill logo, use upload URL
      return `${environment.uploadUrl}uploads/salon_bill_logos/${this.currentUser.billLogo}`;
    }
    // Default logo
    return '';
  }

}



// WEBPACK FOOTER //
// ./src/app/package-receipt/package-receipt.component.ts